// src/features/counter/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  alertMessage: false,
  spotlight: [],
};
export const spotlighSlice = createSlice({
  name: "spotlight",
  initialState,
  reducers: {
    setAlert: (state, action) => {
      state.alertMessage = action.payload;
    },
    setSpotlight: (state, action) => {
      state.spotlight = action.payload;
    },
  },
});

export const { setAlert, setSpotlight } = spotlighSlice.actions;

export default spotlighSlice.reducer;
